import React from 'react';
import { OrderFulfillmentPicture } from '../../../../graphql/generatedTypes';
import i18n from '@/utils/i18n';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { OrderFulfillmentPicturesTable } from './OrderFulfillmentPicturesTable';

type OrderfulfillmentPicturesGalleryProps = {
  pictures?: OrderFulfillmentPicture[];
  onClose: () => void;
};

const OrderfulfillmentPicturesGallery = ({
  pictures,
  onClose,
}: OrderfulfillmentPicturesGalleryProps) => {
  return (
    <Modal isOpen={true} toggle={() => onClose()} fullscreen scrollable={false}>
      <ModalBody>
        <OrderFulfillmentPicturesTable
          pictures={pictures || []}
          loading={false}
          error={undefined}
          total={(pictures || []).length}
          page={1}
          showLinkButton={false}
          showUnlinkButton={false}
          showDownload={true}
        />
      </ModalBody>

      <ModalFooter>
        <Button onClick={() => onClose()} color="secondary">
          {i18n.t('Common:cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OrderfulfillmentPicturesGallery;
